import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class EmailAutofocus extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    $('#loginForm, #registerForm, #passwordResetForm, #magicLinkForm')
      .first()
      .find('input[type="email"]')
      .focus();

    return super.initialize();
  }

}